import React, { Fragment, useEffect } from "react";

import { Link } from "react-router-dom";

import classes from "./LandingPage.module.css";
import carIcon from "../../assets/svg/carICon.svg";
import motoIcon from "../../assets/svg/moto.svg";
import commercialIcon from "../../assets/svg/commercial.svg";
import accessoriesIcon from "../../assets/svg/accessories.svg";
import partsIcon from "../../assets/svg/parts.svg";
import dealersIcon from "../../assets/svg/dealers.svg";
import serviceIcon from "../../assets/svg/service.svg";
import RecentVehicle from "./RecentVehicle/RecentVehicle";
import CommingSoon from "./CommingSoon/CommingSoon";
import Honda from "./../../assets/Img/Honda@2x.png";
import Toyotoa from "./../../assets/Img/ToyotaNet.jpg";
import Nissan from "./../../assets/Img/Nissan@2x.png";
import Proton from "./../../assets/Img/ProtonNet.png";
import Bmw from "./../../assets/Img/BMW@2x.png";
import Mercedez from "./../../assets/Img/Mercedez-Benz@2x.png";
import Mazada from "./../../assets/Img/Mazda.png";
import Mitsubishi from "./../../assets/Img/Mitsubishi@2x.png";
import FeatureDealer from "./FeatureDealer/FeatureDealer";
import Footer from "../UI/Footer/Footer";
import Spinner from "../UI/spinner/Spinner";

const LandingPage = (props) => {
    const typeAllGetFeatured = ()=>{
        if (props.vehicleType === 'all') {
             props.getFeatured('all')
        }
    }
    useEffect(typeAllGetFeatured, [props.vehicleType])
    return (
        <Fragment>
            <div className={classes.LandingPage}>
                <div className={classes.Background} />
                <div className={classes.RletterBackground}>
                    <h4>LATEST VEHICLES</h4>
                    <h1>Discover All Recently Added {localStorage.getItem('vehicleType') === 'all' ? 'Vehicles' : localStorage.getItem('vehicleType')}</h1>
                </div>
                <div className={classes.VehicleTypes}>
                    <input
                        type='radio'
                        name='featuredVehicleTye'
                        id='cars'
                        value='cars'
                        onChange={(event) => { props.getFeatured(event.target.value) }}
                        checked={props.vehicleType === 'all' ? false : props.vehicleType === 'cars' ? true : false}
                    />
                    <label className={classes.type} htmlFor='cars'>
                        <img src={carIcon} alt='cars' />
                        <span>cars</span>
                    </label>
                    <input
                        type='radio'
                        name='featuredVehicleTye'
                        id='motors'
                        value='motors'
                        onChange={(event) => { props.getFeatured(event.target.value) }}
                        checked={props.vehicleType === 'all' ? false : props.vehicleType === 'motors' ? true : false}
                    />
                    <label className={classes.type} htmlFor='motors'>
                        <img src={motoIcon} alt='motors' />
                        <span>Motorcycle</span>
                    </label>
                    <input
                        type='radio'
                        name='featuredVehicleTye'
                        id='commercials'
                        value='commercials'
                        onChange={(event) => { props.getFeatured(event.target.value) }}
                        checked={props.vehicleType === 'all' ? false : props.vehicleType === 'commercials' ? true : false}
                    />
                    <label className={classes.type} htmlFor='commercials'>
                        <img src={commercialIcon} alt='commercials' />
                        <span>Commercial</span>
                    </label>
                    <input
                        type='radio'
                        name='featuredVehicleTye'
                        id='accessories'
                        value='accessories'
                        onChange={(event) => { props.getFeatured(event.target.value) }}
                        checked={props.vehicleType === 'all' ? false : props.vehicleType === 'accessories' ? true : false}
                    />
                    <label className={classes.type} htmlFor='accessories'>
                        <img src={accessoriesIcon} alt='accessories' />
                        <span>Accessories</span>
                    </label>
                    <input
                        type='radio'
                        name='featuredVehicleTye'
                        id='parts'
                        value='parts'
                        onChange={(event) => { props.getFeatured(event.target.value) }}
                        checked={props.vehicleType === 'all' ? false : props.vehicleType === 'parts' ? true : false}
                    />
                    <label className={classes.type} htmlFor='parts'>
                        <img src={partsIcon} alt='parts' />
                        <span>Parts</span>
                    </label>
                    <input
                        type='radio'
                        name='featuredVehicleTye'
                        id='dealers'
                        value='dealers'
                        onChange={(event) => { props.getFeatured(event.target.value) }}
                        checked={props.vehicleType === 'all' ? false : props.vehicleType === 'dealers' ? true : false}
                    />
                    <label className={classes.type} htmlFor='dealers'>
                        <img src={dealersIcon} alt='dealers' />
                        <span>Dealers</span>
                    </label>
                    <input
                        type='radio'
                        name='featuredVehicleTye'
                        id='services'
                        value='services'
                        onChange={(event) => { props.getFeatured(event.target.value) }}
                        checked={props.vehicleType === 'all' ? false : props.vehicleType === 'services' ? true : false}
                    />
                    <label className={classes.type} htmlFor='services'>
                        <img src={serviceIcon} alt='services' />
                        <span>Services</span>
                    </label>
                    <input
                        type='radio'
                        name='featuredVehicleTye'
                        id='rental'
                        value='rental'
                        onChange={(event) => { props.getFeatured(event.target.value) }}
                        checked={props.vehicleType === 'all' ? false : props.vehicleType === 'rental' ? true : false}
                    />
                    <label className={classes.type} htmlFor='rental'>
                        <img src={serviceIcon} alt='rental' />
                        <span>Rental</span>
                    </label>
                </div>
                {props.commingSoon ? <CommingSoon />
                    :
                    props.loadingFeature ?
                        <Spinner /> :
                        <RecentVehicle
                            FeatruedVehicles={props.FeatruedVehicles}
                            routeHistory={props.routeHistory}
                            wishIdsArray={props.wishIdsArray}
                            user={props.user}
                            AddItemToWishList={props.AddItemToUserWishList}
                            showAuthHandler={props.showAuthHandler}
                            addingItem={props.addingItem}
                        />
                }
                {
                    // props.loadingFeature ?
                    //     <Spinner /> :
                    //     <RecentVehicle
                    //         FeatruedVehicles={props.FeatruedVehicles}
                    //         routeHistory={props.routeHistory}
                    //         wishIdsArray={props.wishIdsArray}
                    //         user={props.user}
                    //         AddItemToWishList={props.AddItemToUserWishList}
                    //         showAuthHandler={props.showAuthHandler}
                    //         addingItem={props.addingItem}
                    //     />
                }
                {props.vehicleType === 'cars' | props.vehicleType === 'motors' ?
                    (<Fragment>
                        <div className={classes.PletterBackground}>
                            <h4>VEHICLES BRANDS</h4>
                            <h1>Popular Brands / Makes</h1>
                        </div>
                        <div className={classes.VehicleTypes}>
                            <div className={classes.Brand}>
                                <Link to='/Search?brand=honda' target={'_blank'}>
                                    <img src={Honda} alt='cars' width='50px' />
                                </Link>
                            </div>
                            <div className={classes.Brand}>
                                <Link to='/Search?brand=Toyotoa' target={'_blank'}>
                                    <img src={Toyotoa} alt='cars' width='50px' />
                                </Link>
                            </div>
                            <div className={classes.Brand}>
                                <Link to='/Search?brand=Nissan' target={'_blank'}>
                                    <img src={Nissan} alt='cars' width='50px' />
                                </Link>
                            </div>
                            <div className={classes.Brand}>
                                <Link to='/Search?brand=Proton' target={'_blank'}>
                                    <img src={Proton} alt='cars' width='50px' />
                                </Link>
                            </div>
                            <div className={classes.Brand}>
                                <Link to='/Search?brand=Bmw' target={'_blank'}>
                                    <img src={Bmw} alt='cars' width='50px' />
                                </Link>
                            </div>
                            <div className={classes.Brand}>
                                <Link to='/Search?brand=Mercedez' target={'_blank'}>
                                    <img src={Mercedez} alt='cars' width='50px' />
                                </Link>
                            </div>
                            <div className={classes.Brand}>
                                <Link to='/Search?brand=Mitsubishi' target={'_blank'}>
                                    <img src={Mitsubishi} alt='cars' width='50px' />
                                </Link>
                            </div>
                            <div className={classes.Brand}>
                                <Link to='/Search?brand=Mazada' target={'_blank'}>
                                    <img src={Mazada} alt='cars' width='50px' />
                                </Link>
                            </div>
                        </div>
                    </Fragment>)
                    :
                    null
                }

                <div className={classes.DletterBackground}>
                    <h4>Best Performing Dealers</h4>
                    <h1>Featured Dealers</h1>
                    <h3>VIEW FULL LIST</h3>
                </div>
                {
                    props.loadingDealers ?
                        <Spinner /> :
                        <FeatureDealer FeatruedDealers={props.FeatruedDealers} routeHistory={props.routeHistory} />
                }
            </div>
            <Footer />
        </Fragment>
    )
};

export default LandingPage;